import { Navigate, Outlet, useLocation } from "react-router";

import { useSelector } from "react-redux";
import SideNavBar from "../SideNavBar/SideNavBar";

const RequiredAuth = () => {
  const location = useLocation();
  const userState = useSelector((state) => state.auth.user);
  return (
    <>
      {userState ? (
        <>
          {/* <NavBar /> */}
          {/* <Box sx={{ p: 2 }}>
            <Outlet />
            </Box> */}
          <SideNavBar>
            <Outlet />
          </SideNavBar>
        </>
      ) : (
        <Navigate to="/login" state={{ from: location }} replace />
      )}
    </>
  );
};

export default RequiredAuth;
